import React from "react";
import cn from "classnames";

import { useContent } from "src/hooks";

import styles from "./style.module.scss";

export const usePending = () => {
  const content = useContent();

  const getPendingProps = React.useCallback(
    () => ({
      className: cn(styles[content]),
    }),
    [content]
  );

  return { getPendingProps };
};
